import React, {
  useState, Fragment, useEffect, isValidElement,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PaymentTermActions from '@Actions/configurations/paymentTermActions';
import H3Text from '@Uilib/h3Text';
/**
 * PaymentTermForm component
 *
 * @param file
 */
const PaymentTermForm = ({
  createPaymentTermLoading, updatePaymentTermLoading, selectedPaymentTerm, createPaymentTerm, user, updatePaymentTerm, selectedDays,
  paymentTerms, callback,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [dueDays, setDueDays] = useState('');
  const [remark, setRemark] = useState('');
  // const [allPaymentTerms, setAllPaymentTerms] = useState(paymentTerms);

  useEffect(() => {
    if (selectedPaymentTerm) {
      // setAdvanceAmount(selectedPaymentTerm?.advance_amount);
      setDueDays(selectedPaymentTerm?.due_days);
      setRemark(selectedPaymentTerm?.remark);
    }
  }, [selectedPaymentTerm]);

  /**
   *
   */
  const addPaymentTerm = () => {
    setFormSubmitted(true);
    if (dueDays && !selectedDays()?.includes(Number(dueDays))) {
      if (selectedPaymentTerm) {
        const copyAllPaymentTerms = paymentTerms?.map((item) => {
          if (item.index === selectedPaymentTerm.index) {
            return ({
              due_days: dueDays,
              remark: '-',
            });
          }
          return ({
            ...item,
          });
        })?.map((item) => ({
          due_days: item?.due_days,
          remark: '-',
        }));
        const payload = {
          org_id: user?.tenant_info?.org_id,
          payment_terms: copyAllPaymentTerms,
        };
        updatePaymentTerm(payload, () => {
          callback();
        });
      } else {
        const payload = {
          org_id: user?.tenant_info?.org_id,
          payment_terms: [...(paymentTerms || [])?.map((item) => ({
            due_days: item?.due_days,
            remark: '-',
          })), {
            due_days: dueDays,
            remark: '-',
          }],
        };
        createPaymentTerm(payload, () => {
          callback(dueDays);
        });
      }
    }
  };

  return (
    <Fragment>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <H3FormInput
            type="number"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder=""
            onChange={(event) => {
              setDueDays(event.target.value);
            }}
            value={dueDays}
            label="Number of Days"
            maxlength="100"
            required
            disabled={createPaymentTermLoading || updatePaymentTermLoading}
          />
          {(formSubmitted && (!dueDays || selectedDays().includes(Number(dueDays)))) && <H3Text className="input-error" text="The payment term already exists" />}
          {formSubmitted && parseInt(dueDays) < 0 && <H3Text className="input-error" text="The number of days cannot be 0" />}
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text={selectedPaymentTerm ? 'Update Payment Term' : 'Add Payment Term'}
            onClick={() => addPaymentTerm()}
            isLoading={createPaymentTermLoading || updatePaymentTermLoading}
            disabled={createPaymentTermLoading || updatePaymentTermLoading}
            style={{
              width: '180px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, PaymentTermsReducers }) => ({
  user: UserReducers.user,
  createPaymentTermLoading: PaymentTermsReducers.createPaymentTermLoading,
  updatePaymentTermLoading: PaymentTermsReducers.updatePaymentTermLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createPaymentTerm: (payload, callback) => dispatch(PaymentTermActions.createPaymentTerm(payload, callback)),
  updatePaymentTerm: (payload, callback) => dispatch(PaymentTermActions.updatePaymentTerm(payload, callback)),
});

PaymentTermForm.propTypes = {
  createPaymentTermLoading: PropTypes.bool,
  updatePaymentTermLoading: PropTypes.bool,
  createPaymentTerm: PropTypes.func,
  updatePaymentTerm: PropTypes.func,
  selectedDays: PropTypes.func,
  selectedPaymentTerm: PropTypes.any,
  callback: PropTypes.any,
  user: PropTypes.any,
  paymentTerms: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PaymentTermForm));
